/* eslint-disable @reatom/unit-naming-rule */
import { action, atom } from '@reatom/framework'

import type { ServicesApi } from '@root/shared/api'

export type PriceChartInterval = 'minutes' | 'seconds'

export const reatomPairPriceChart = (dto: ServicesApi.PairDto) => {
  const priceChartMinutesAtom = atom(
    dto.priceChart.interval === '1M' ? dto.priceChart.entries : [],
  )

  const priceChartSecondsAtom = atom(
    dto.priceChart.interval === '1S' ? dto.priceChart.entries : [],
  )

  /**
   * An update with no candles is not an update.
   *
   * The market pulse rebuilds a card without asking for a chart, so the card
   * it sends carries `{ interval: '1M', entries: [] }` — an empty block that
   * matched on interval and overwrote the thirty candles the feed snapshot
   * had loaded. The sparkline went blank a couple of seconds after the
   * column appeared, and stayed blank, because every following tick wrote
   * the same nothing over it again.
   *
   * Refusing an empty list is the right guard rather than filtering on the
   * sender: a chart we were not given is not a chart that became empty, and
   * no caller has ever wanted to clear this by sending zero entries.
   */
  const updateFromDtoAction = action(
    (ctx, dto: ServicesApi.PairDto['priceChart']) => {
      if (dto.entries.length === 0) {
        return
      }

      if (dto.interval === '1M') {
        priceChartMinutesAtom(ctx, dto.entries)
      }

      if (dto.interval === '1S') {
        priceChartSecondsAtom(ctx, dto.entries)
      }
    },
  )

  return {
    priceChartMinutes: priceChartMinutesAtom,
    priceChartSeconds: priceChartSecondsAtom,
    updateFromDtoAction,
  }
}
